export enum TransportManagementReportName {
  To = 'to',
  Load = 'load',
}
